import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'bytesConverter',
  standalone: true,
})
export class BytesConverterPipe implements PipeTransform {
  transform(value: number, decimals = 2): string {
    if (!+value) return '0 bytes';
    if (value >= 1e12) return 'unsupported value';

    const k = 1000;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['bytes', 'kb', 'mb', 'gb'];
    const i = Math.floor(Math.log(value) / Math.log(k));
    return `${parseFloat((value / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
  }
}
